import { Routes } from '@angular/router';
import { provideReflectionStore } from '@app/store/reflection';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const reflectionsModalRoutes: Routes = [
    {
        path: 'reflections/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideReflectionStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'reflections/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideReflectionStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'reflections/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideReflectionStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
